export default "__VITE_ASSET__CjkqBquy__"